import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageBusinessUnits = lazy(() => import("./layout/index"));

export const routersPageBusinessUnits: RouterItemType[] = [
  {
    path: "/businessunits",
    authorize: true,
    element: <LayoutPageBusinessUnits />,
  },
  {
    path: "/business-units",
    authorize: true,
    element: <LayoutPageBusinessUnits />,
  },
];
